import ConfirmModal from "../Components/Common/Modal/ConfirmModal";
import SavPreview from "../Components/Sav/SavPreview/SavPreview";
import UpdateTicketSav from "../Components/Sav/UpdateTicketSavAdmin/UpdateTicketSav";
import { openCenteredModal } from "../REDUX/actions/centeredModal";
import { openRightModal } from "../REDUX/actions/rightModal";
import {
  deleteTicketSAV,
  updateTicketSAVStatus,
} from "../REDUX/actions/ticketSAV";

export const extractRevendeurOfSav = (users) => {
  return users.data?.find((user) => user?.attributes?.userRole === 0);
};
export const extractResponsableOfSav = (users) => {
  return users.data?.find((user) => user?.attributes?.userRole === 1);
};
export const generateOptionsBasedOnRole = (
  userRole,
  id,
  dispatch,
  t,
  userId,
  oldStatus,
) => {
  const roleOptionsMap = {
    admin: [
      // {
      //   text: "Modifier le ticket",
      //   callback: () => dispatch(openRightModal(<UpdateTicketSav id={id} />)),
      // },
      {
        text: t("View the ticket"),
        callback: () => dispatch(openRightModal(<UpdateTicketSav id={id} />)),
      },
      {
        text: t("Resolve the ticket"),
        hidden: oldStatus === 2,
        callback: () =>
          dispatch(
            updateTicketSAVStatus(
              { id: id, data: { status: 2, oldStatus, userId } },
              t,
            ),
          ),
      },
      {
        text: t("Reopen the ticket"),
        hidden: oldStatus != 2 && oldStatus !== 3,
        callback: () =>
          dispatch(
            updateTicketSAVStatus(
              { id: id, data: { status: 1, oldStatus, userId } },
              t,
            ),
          ),
      },
      {
        text: t("Reopen the ticket"),
        hidden: oldStatus != 2 && oldStatus !== 3,
        callback: () =>
          dispatch(
            updateTicketSAVStatus(
              { id: id, data: { status: 1, oldStatus, userId } },
              t
            )
          ),
      },
      {
        text: t("Cancel the ticket"),
        orange: true,
        hidden: oldStatus === 3,
        callback: () =>
          dispatch(
            updateTicketSAVStatus(
              { id: id, data: { status: 3, oldStatus, userId } },
              t,
            ),
          ),
      },
      {
        text: t("Delete the ticket"),
        red: true,
        callback: () =>
          dispatch(
            openCenteredModal(
              <ConfirmModal
                label={t("AS ticket")}
                id={id}
                onConfirm={() => dispatch(deleteTicketSAV(id))}
              />,
            ),
          ),
      },
    ],
    reseller: [
      {
        text: t("View the ticket"),
        callback: () => dispatch(openRightModal(<SavPreview id={id} />)),
      },
      // {
      //   text: "Modifier le ticket",
      //   callback: () => dispatch(openRightModal(<UpdateTicketSav id={id} />)),
      // },
      // {
      //   text: "Annuler le ticket",
      //   red: true,
      //   callback: () =>
      //     dispatch(updateTicketSAVStatus({ id: id, data: { status: 3 } })),
      // },
    ],
    BusinessBroker: [
      {
        text: t("View the ticket"),
        callback: () => dispatch(openRightModal(<UpdateTicketSav id={id} />)),
      },
      {
        text: t("Resolve the ticket"),
        callback: () =>
          dispatch(
            updateTicketSAVStatus(
              { id: id, data: { status: 2, oldStatus, userId } },
              t,
            ),
          ),
      },
      {
        text: t("Cancel the ticket"),
        orange: true,
        callback: () =>
          dispatch(
            updateTicketSAVStatus(
              { id: id, data: { status: 3, oldStatus, userId } },
              t,
            ),
          ),
      },
      {
        text: t("Delete the ticket"),
        red: true,
        callback: () =>
          dispatch(
            openCenteredModal(
              <ConfirmModal
                label={t("AS ticket")}
                id={id}
                onConfirm={() => dispatch(deleteTicketSAV(id))}
              />,
            ),
          ),
      },
    ],
  };
  const options = roleOptionsMap[userRole] || [];

  return options;
};

export const getResponsableNotificationCount = (notififications) => {
  return notififications?.filter(
    (notification) =>
      notification?.attributes?.comment?.data &&
      notification?.attributes?.comment?.data?.attributes?.onlyAdmin,
  )?.length;
};

export const getResellerNotificationCount = (notifications) => {
  return notifications?.filter(
    (notification) =>
      notification?.attributes?.comment?.data &&
      !notification?.attributes?.comment?.data?.attributes?.onlyAdmin,
  )?.length;
};

export const getAttachmentNotificationCount = (notifications) => {
  return notifications?.filter(
    (notification) => notification?.attributes?.type === "attachment",
  )?.length;
};

export const getTicketNotificationCount = (notifications) => {
  return notifications?.filter(
    (notification) => notification?.attributes?.type === "status",
  )?.length > 0
    ? 1
    : 0;
};
